import { useContext } from "react";
import { EmailTemplateContext } from "../EmailTemplateContext";
import { Divider } from "../elements/Divider";
import { Mailtext } from "../elements/Mailtext";
import { Plaintext } from "../elements/Plaintext";
import { ButtonElement } from "../elements/ButtonElement";
import { List } from "../elements/List";
import backpack from "@/assets/images/email/backpack.png";
import click from "@/assets/images/email/click.png";

export const StatusEmail = () => {
  const ctx = useContext(EmailTemplateContext);

  if (!ctx) return null;

  const {
    data,
    template: { template },
  } = ctx;

  const salutation = template?.find(t => t.position === "salutation");

  return (
    <>
      <Divider imageSrc={backpack} alt="backpack icon" />
      {salutation?.text && <Plaintext template={salutation} innerRef={data.current[9]} />}
      <List template={template[1]!} innerRef={data.current[1]} />
      {template[2]?.text && <Plaintext template={template[2]} innerRef={data.current[2]} />}
      <Divider imageSrc={click} />
      <Plaintext template={template[3]!} innerRef={data.current[3]} />
      <ButtonElement template={template[4]!} innerRef={data.current[4]} />
      <Plaintext template={template[5]!} innerRef={data.current[5]} />
      {template[6]?.type === "mailto" ? (
        <Mailtext template={template[6]} innerRef={data.current[6]} />
      ) : (
        <Plaintext template={template[6]!} innerRef={data.current[6]} />
      )}
      {template[7] && template[7].text && (
        <>
          <Plaintext template={template[7]} innerRef={data.current[7]} />
          <Plaintext template={template[8]!} innerRef={data.current[8]} />
        </>
      )}
    </>
  );
};
